import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { RaportUtargJakiSpZaplatySpZaplaty, RaportUtargJakiSpZaplatySuma, VatHeder, VatTableRow, VatTableVat, VatNotes, VatInstalacja, RezerwacjaPobyt } from "../../api";
import ContainerPdf from "./ContainerPdf";
import { dwaMiejscaPoPrzecinku, oddzielTysiace } from "../common/helpers";


interface FakturaPdfProps {
    tytul: string,
    koniecWydrukuOpis: string,

    daneGorne: VatHeder,
    tableRows: VatTableRow[],
    tableRowsVat: VatTableVat[],
    fakturaNotes: VatNotes[],
    fakturaSprzedawca: VatInstalacja,
    logo: string,
    rezerwacja: RezerwacjaPobyt
}

class FakturaPdf extends React.Component<FakturaPdfProps, any> {

    getCellStyle = (_font_styl: number) => {
        let style: any = {}

        if (_font_styl === 0) {
            style = { font: "normal" }
        } else if (_font_styl === 3) {
            style = { font: "italic" }
        }

        return style
    };


    public render() {

        let tableVat = [...this.props.tableRowsVat]
        if(this.props.tableRowsVat.length > 0){
            tableVat.push({
                brutto: oddzielTysiace(dwaMiejscaPoPrzecinku( this.props.tableRowsVat.reduce((a,b) => (a + Number(b.brutto)), 0).toString() )),
                dokNr: this.props.tableRowsVat[0].dokNr,
                netto: oddzielTysiace(dwaMiejscaPoPrzecinku( this.props.tableRowsVat.reduce((a,b) => (a + Number(b.netto)), 0).toString() )),
                przydzial: this.props.tableRowsVat[0].przydzial,
                vat: oddzielTysiace(dwaMiejscaPoPrzecinku( this.props.tableRowsVat.reduce((a,b) => (a + Number(b.vat)), 0).toString() )),
                vatStawka: "razem"
            })
            //console.log(tableVat)
            //console.log(this.props.tableRowsVat.reduce((a,b) => (a + Number(b.brutto)), 0).toString())
            //console.log(oddzielTysiace(dwaMiejscaPoPrzecinku( this.props.tableRowsVat.reduce((a,b) => (a + Number(b.brutto)), 0).toString() )))
        }
           

        return (
            <ContainerPdf tytul={this.props.tytul}  koniecWydrukuOpis={this.props.koniecWydrukuOpis} daneGorne={this.props.daneGorne} fakturaNotes={this.props.fakturaNotes} fakturaSprzedawca={this.props.fakturaSprzedawca} logo={this.props.logo} rezerwacja={this.props.rezerwacja} >
                <View style={styles.table}>
                    <View style={styles.tableRow} fixed>
                        <View style={styles.tableHeader1}>
                            <Text style={styles.tableCellHeaderLeft}>
                                lp
                            </Text>
                        </View>
                        <View style={styles.tableHeader2}>
                            <Text style={styles.tableCellHeaderLeft}>
                                usługi i towary
                            </Text>
                        </View>
                        <View style={styles.tableHeader3}>
                            <Text style={styles.tableCellHeaderLeft}>
                                jm
                            </Text>
                        </View>
                        <View style={styles.tableHeader4}>
                            <Text style={styles.tableCellHeaderRight}>
                                ilość
                            </Text>
                        </View>
                        <View style={styles.tableHeader5}>
                            <Text style={styles.tableCellHeaderRight}>
                                cena
                            </Text>
                        </View>
                        <View style={styles.tableHeader6}>
                            <Text style={styles.tableCellHeaderRight}>
                                vat %
                            </Text>
                        </View>
                        <View style={styles.tableHeader7}>
                            <Text style={styles.tableCellHeaderRight}>
                                netto
                            </Text>
                        </View>
                        <View style={styles.tableHeader8}>
                            <Text style={styles.tableCellHeaderRight}>
                                vat
                            </Text>
                        </View>
                        <View style={styles.tableHeader9}>
                            <Text style={styles.tableCellHeaderRight}>
                                brutto
                            </Text>
                        </View>
                    </View>


                    {this.props.tableRows.map((row, index) => (
                        <View
                            key={index}
                            style={{
                                ...styles.tableRowContent,
                                borderBottomWidth: index === (this.props.tableRows.length - 1) ? 1 : 0
                            }}
                        >
                            <View style={styles.tableCol1}>
                                <Text style={{ ...styles.tableCellLeft }}>
                                    {row.dokLp}
                                </Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={{ ...styles.tableCellLeft }}>
                                    {row.asortNazwa}
                                </Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={{ ...styles.tableCellLeft }}>
                                    {row.jm}
                                </Text>
                            </View>
                            <View style={styles.tableCol4}>
                                <Text style={{ ...styles.tableCellRight }}>
                                    {row.ilosc}
                                </Text>
                            </View>
                            <View style={styles.tableCol5}>
                                <Text style={{ ...styles.tableCellRight}}>
                                    {oddzielTysiace(dwaMiejscaPoPrzecinku(row.cenaBrutto))}
                                </Text>
                            </View>
                            <View style={styles.tableCol6}>
                                <Text style={{ ...styles.tableCellRight }}>
                                    {row.vatStawka}
                                </Text>
                            </View>
                            <View style={styles.tableCol7}>
                                <Text style={{ ...styles.tableCellRight }}>
                                    {oddzielTysiace(dwaMiejscaPoPrzecinku(row.netto))}
                                </Text>
                            </View>
                            <View style={styles.tableCol8}>
                                <Text style={{ ...styles.tableCellRight}}>
                                    {oddzielTysiace(dwaMiejscaPoPrzecinku(row.vat))}
                                </Text>
                            </View>
                            <View style={styles.tableCol9}>
                                <Text style={{ ...styles.tableCellRight}}>
                                    {oddzielTysiace(dwaMiejscaPoPrzecinku(row.brutto))}
                                </Text>
                            </View>
                        </View>
                    ))}
                </View>

                <View wrap={false}>
                    <View style={styles.table2}>
                        {tableVat.map((row, index) => (
                            <View
                                key={1000 + index}
                                style={{
                                    ...styles.table2RowContent,
                                    borderBottomWidth: index === (tableVat.length - 1) ? 1 : 0
                                }}
                            >
                                <View style={styles.tableCol6}>
                                    <Text style={{ ...styles.tableCellRight }}>
                                        {row.vatStawka}
                                    </Text>
                                </View>
                                <View style={styles.tableCol7}>
                                    <Text style={{ ...styles.tableCellRight }}>
                                        {oddzielTysiace(dwaMiejscaPoPrzecinku(row.netto))}
                                    </Text>
                                </View>
                                <View style={styles.tableCol8}>
                                    <Text style={{ ...styles.tableCellRight }}>
                                        {oddzielTysiace(dwaMiejscaPoPrzecinku(row.vat))}
                                    </Text>
                                </View>
                                <View style={styles.tableCol9}>
                                    <Text style={{ ...styles.tableCellRight }}>
                                        {oddzielTysiace(dwaMiejscaPoPrzecinku(row.brutto))}
                                    </Text>
                                </View>
                            </View>
                        ))}
                    </View>

                    <View style={styles.table2}>
                            <View
                                key={100}
                                style={{
                                    ...styles.table2RowContent,
                                    borderBottomWidth: 1 
                                }}
                            >
                                <View style={styles.table3Col8}>
                                    <Text style={{ ...styles.tableCellRight}}>
                                        {"[ - ]"} {/*Zaliczka_*/}
                                    </Text>
                                </View>
                                <View style={styles.tableCol9}>
                                    <Text style={{ ...styles.tableCellRight }}>
                                        {oddzielTysiace(dwaMiejscaPoPrzecinku(this.props.daneGorne.zaliczka))}
                                    </Text>
                                </View>
                            </View>

                             <View
                             key={101}
                             style={{
                                 ...styles.table2RowContent,
                                 borderBottomWidth: 0
                             }}
                         >
                             <View style={styles.table3Col8}>
                                 <Text style={{ ...styles.tableCellRight, fontStyle: "bold" }}>
                                     {"Do zapłaty PLN"}
                                 </Text>
                             </View>
                             <View style={styles.tableCol9}>
                                 <Text style={{ ...styles.tableCellRight, fontStyle: "bold"  }}>
                                     {oddzielTysiace(dwaMiejscaPoPrzecinku(this.props.daneGorne.brutto))}
                                 </Text>
                             </View>
                         </View>
                    </View>
                </View>

                
            </ContainerPdf>
        )
    };
}

//const HEADER_BACKBROUND = '#f6f6f6'
const HEADER_BACKBROUND = '#E3E3E3'
//const BORDER_COLOR = '#e4e3e2'
const BORDER_COLOR = '#666666'
const BORDER_STYLE = 'solid'
const COL1_WIDTH = 4
const COL2_WIDTH = 46
const COL3_WIDTH = 6
const COL4_WIDTH = 6
const COL5_WIDTH = 8
const COL6_WIDTH = 6
const COL7_WIDTH = 8  // *3
const COL8_WIDTH = 8  // *3
const COL9_WIDTH = 8  // *3
const FONT_SIZE = 8;
const styles = StyleSheet.create({
    table: {
        width: "auto",
        borderWidth: 0,
    },
    table2: {
        width: "auto",
        borderWidth: 0,
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
        //backgroundColor: 'rgb(246, 246, 246)',
        border: "1px solid black",
    },
    tableRow3: {
        margin: "auto",
        flexDirection: "row",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomWidth: 1
    },
    tableRowContent: {
        margin: "auto",
        float: "right",
        flexDirection: "row",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        paddingTop: 4,
        paddingBottom: 4
    },
    table2RowContent: {
        margin: " 0 0 0 auto",
        flexDirection: "row",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        paddingTop: 4,
        paddingBottom: 4
    },
    tableHeader1: {
        width: COL1_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
    },
    tableHeader2: {
        width: COL2_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableHeader3: {
        width: COL3_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableHeader4: {
        width: COL4_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableHeader5: {
        width: COL5_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableHeader6: {
        width: COL6_WIDTH + '%',
        //borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableHeader7: {
        width: COL7_WIDTH + '%',
        //borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableHeader8: {
        width: COL8_WIDTH + '%',
        //borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableHeader9: {
        width: COL9_WIDTH + '%',
        //borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px",
        borderLeft: "1px"
    },
    tableCol1HeaderRow2: {
        width: COL1_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "3px",
        paddingBottom: "3px"
    },
    tableCol2HeaderRow2: {
        width: COL2_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "2px",
        paddingBottom: "3px"
    },
    tableCol3HeaderRow2: {
        width: COL3_WIDTH + '%',
        borderWidth: 0,
        backgroundColor: HEADER_BACKBROUND,
        paddingTop: "2px",
        paddingBottom: "3px"
    },
    tableCol1: {
        width: COL1_WIDTH + '%',
    },
    tableCol2: {
        width: COL2_WIDTH + '%',
    },
    tableCol3: {
        width: COL3_WIDTH + '%',
    },
    tableCol4: {
        width: COL4_WIDTH + '%',
    },
    tableCol5: {
        width: COL5_WIDTH + '%',
    },
    tableCol6: {
        width: COL6_WIDTH + '%',
    },
    tableCol7: {
        width: COL7_WIDTH + '%',
    },
    table3Col7: {
        width: COL7_WIDTH + 1 + '%',
    },
    tableCol8: {
        width: COL8_WIDTH + '%',
    },
    table3Col8: {
        width: COL8_WIDTH + 5 + '%',
    },

    tableCol9: {
        width: COL9_WIDTH + '%',
    },
    table3Col9: {
        width: COL9_WIDTH + '%',
    },
    tableCellHeaderRight: {
        //color: "#3a87ad",
        fontSize: FONT_SIZE,
        textAlign: 'right',
        marginRight: '6px'
    },
    tableCellHeaderLeft: {
        //color: "#3a87ad",
        fontSize: FONT_SIZE,
        textAlign: 'left',
        marginLeft: '6px',
        display: "flex",
        flexDirection: "row"
    },
    tableCellRight: {
        fontSize: FONT_SIZE,
        textAlign: 'right',
        marginRight: '6px',
    },
    tableCellLeft: {
        fontSize: FONT_SIZE,
        textAlign: 'left',
        marginLeft: '6px',
    },
    inline: {
        display: "flex",
        flexDirection: "row"
    },
});

export default FakturaPdf;
